let data = [
    {
        id: 0,
        number:1,
        title:"Good!",
        name:"Ikk98***",
        date:"2022/04/12"
    },
    {
        id: 1,
        number:2,
        title:"I eat fresh vegetables every day",
        name:"98mnkk***",
        date:"2022/04/20"
    },
    {
        id: 2,
        number:3,
        title:"I used early morning delivery for the first time and it was good",
        name:"mia**",
        date:"2022/05/02"

    },
    {
        id : 3,
        number:4,
        title:"I subscribed to get the kit",
        name:"seph****",
        date:"2022/05/05"
      },
    {
      id : 4,
      number:5,
      title:"kids like it",
      name:"1220in*****",
      date:"2022/04/12"
    }
]

export default data;